import React from 'react';
import { Navigate, Route, useLocation } from 'react-router-dom';

import LayoutEmpty from '../components/layouts/LayoutEmpty';
import LayoutMain from '../components/layouts/LayoutMain';
import ErrorPage from '../pages/404';
import Customers from '../pages/customers';
import Dashboard from '../pages/dashboard';
import DestPoint from '../pages/destPoint';
import Drivers from '../pages/drivers';
import Login from '../pages/login';
import Products from '../pages/products';
import Results from '../pages/results';
import Vehicles from '../pages/vehicles';

type RouterType = {
 path: string;
 element: React.ReactNode;
 layout: React.ElementType;
 children?: RouterType[];
 requiresAuth?: boolean;
};

export const router = [
 {
  path: '/',
  element: <Results />,
  layout: LayoutMain,
  requiresAuth: true,
 },
 {
  path: '/login',
  element: <Login />,
  layout: LayoutEmpty,
  requiresAuth: false,
 },
 {
  path: '/results',
  layout: LayoutMain,
  element: <Results />,
 },
 {
  path: '/customers',
  layout: LayoutMain,
  element: <Customers />,
 },
 {
  path: '/drivers',
  layout: LayoutMain,
  element: <Drivers />,
 },
 {
  path: '/vehicles',
  layout: LayoutMain,
  element: <Vehicles />,
 },
 {
  path: '/products',
  layout: LayoutMain,
  element: <Products />,
 },
 {
  path: '/destPoint',
  layout: LayoutMain,
  element: <DestPoint />,
 },
 {
  path: '/dashboard',
  layout: LayoutMain,
  element: <Dashboard />,
 },
 // 404 page with MinimalLayout
 {
  path: '*',
  element: <ErrorPage />,
  layout: LayoutEmpty,
  requiresAuth: false,
 },
];

// Protected Route component

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
 // const { isAuthenticated } = useAuth();

 const location = useLocation();

 const isAuthenticated = true;

 if (!isAuthenticated) {
  // Redirect to login if not authenticated

  return <Navigate to="/login" state={{ from: location }} replace />;
 }

 return children;
};

// Recursive function to generate routes

export const generateRoutes = (routesList: RouterType[]) =>
 routesList.map((route) => {
  const RouteLayout = route.layout;

  const RouteElement = route.element;

  if (route.children) {
   return (
    <Route
     key={route.path}
     path={route.path}
     errorElement={<ErrorPage />}
     element={
      route.requiresAuth ? (
       <ProtectedRoute>
        <RouteLayout>{RouteElement}</RouteLayout>
       </ProtectedRoute>
      ) : (
       <RouteLayout>{RouteElement}</RouteLayout>
      )
     }
    >
     {generateRoutes(route.children)}
    </Route>
   );
  }

  return (
   <Route
    key={route.path}
    path={route.path}
    element={
     route.requiresAuth ? (
      <ProtectedRoute>
       <RouteLayout>{RouteElement}</RouteLayout>
      </ProtectedRoute>
     ) : (
      <RouteLayout>{RouteElement}</RouteLayout>
     )
    }
   />
  );
 });
